var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAddPersonalIncentive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3383 5.49922C12.6716 5.49922 12.9383 5.23255 12.9383 4.89922V1.79922C12.9383 1.46589 12.6716 1.19922 12.3383 1.19922C12.0049 1.19922 11.7383 1.46589 11.7383 1.79922V4.89922C11.7383 5.22589 12.0116 5.49922 12.3383 5.49922Z",
    fill: "#116584"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99844 10.5C7.6651 10.5 7.39844 10.7667 7.39844 11.1V14.2C7.39844 14.5333 7.6651 14.8 7.99844 14.8C8.33177 14.8 8.59844 14.5333 8.59844 14.2V11.1C8.59844 10.7733 8.33177 10.5 7.99844 10.5Z",
    fill: "#116584"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65859 5.49922C3.99193 5.49922 4.25859 5.23255 4.25859 4.89922V1.79922C4.25859 1.46589 3.99193 1.19922 3.65859 1.19922C3.32526 1.19922 3.05859 1.46589 3.05859 1.79922V4.89922C3.05859 5.22589 3.32526 5.49922 3.65859 5.49922Z",
    fill: "#116584"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90031 6.7793H2.42031C2.08698 6.7793 1.82031 7.04596 1.82031 7.3793C1.82031 7.71263 2.08698 7.9793 2.42031 7.9793H3.06031V14.1993C3.06031 14.5326 3.32698 14.7993 3.66031 14.7993C3.99365 14.7993 4.26031 14.5326 4.26031 14.1993V7.9793H4.90031C5.23365 7.9793 5.50031 7.71263 5.50031 7.3793C5.50031 7.04596 5.22698 6.7793 4.90031 6.7793Z",
    fill: "#116584"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.58 6.7793H11.1C10.7667 6.7793 10.5 7.04596 10.5 7.3793C10.5 7.71263 10.7667 7.9793 11.1 7.9793H11.74V14.1993C11.74 14.5326 12.0067 14.7993 12.34 14.7993C12.6733 14.7993 12.94 14.5326 12.94 14.1993V7.9793H13.58C13.9133 7.9793 14.18 7.71263 14.18 7.3793C14.18 7.04596 13.9133 6.7793 13.58 6.7793Z",
    fill: "#116584"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24016 8.01922H8.60016V1.79922C8.60016 1.46589 8.33349 1.19922 8.00016 1.19922C7.66682 1.19922 7.40016 1.46589 7.40016 1.79922V8.01922H6.76016C6.42682 8.01922 6.16016 8.28588 6.16016 8.61922C6.16016 8.95255 6.42682 9.21922 6.76016 9.21922H9.24016C9.57349 9.21922 9.84016 8.95255 9.84016 8.61922C9.84016 8.28588 9.57349 8.01922 9.24016 8.01922Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPersonalIncentive);
export default __webpack_public_path__ + "static/media/ic-add-personal-incentive.90b509cbb8e163d909d85fe3e47f32af.svg";
export { ForwardRef as ReactComponent };